var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerMenuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.6618C20 13.2999 19.7001 13.0001 19.3382 13.0001H0.661765C0.299862 13.0001 0 13.2999 0 13.6618V14.9854C0 15.3473 0.299862 15.6471 0.661765 15.6471H19.3382C19.7001 15.6471 20 15.3473 20 14.9854V13.6618ZM20 7.33832C20 6.97642 19.7001 6.67656 19.3382 6.67656H0.661765C0.299862 6.67656 0 6.97642 0 7.33832V8.66185C0 9.02375 0.299862 9.32362 0.661765 9.32362H19.3382C19.7001 9.32362 20 9.02375 20 8.66185V7.33832ZM20 1.01479C20 0.652889 19.7001 0.353027 19.3382 0.353027H0.661765C0.299862 0.353027 0 0.652889 0 1.01479V2.33832C0 2.70022 0.299862 3.00009 0.661765 3.00009H19.3382C19.7001 3.00009 20 2.70022 20 2.33832V1.01479Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMenuDark);
export default __webpack_public_path__ + "static/media/banner-menu-dark.790c90f1b5bf2564105e6ee3538ffa96.svg";
export { ForwardRef as ReactComponent };